import { useState, useCallback } from "react";

const STORAGE_KEY = "mo_dashboard_tour_completed";

export const useDashboardTour = () => {
  const [showTour, setShowTour] = useState(() => {
    try {
      return !localStorage.getItem(STORAGE_KEY);
    } catch {
      return false;
    }
  });

  const startTour = useCallback(() => setShowTour(true), []);

  const endTour = useCallback(() => {
    setShowTour(false);
    try {
      localStorage.setItem(STORAGE_KEY, "true");
    } catch {}
  }, []);

  return { showTour, startTour, endTour };
};
